<template>
  <fieldset>
    <SignupLegend title="Create your aio* account"/>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Work email</label>
      <div class="col-sm-9">
        <input type="email" class="form-control" placeholder="email" v-model="formData.admin.email" required>
        <div class="invalid-feedback">Valid email address is required.</div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Password</label>
      <div class="col-sm-9">
        <input type="password" class="form-control" autocomplete="new-password" minlength="9"
               placeholder="create password" v-model="formData.admin.password" required>
        <div class="invalid-feedback">Password with at least 9 characters is required.</div>
      </div>
    </div>
    <BaseNaviButtons :noBack="true" :toSubmit="formData">
      <slot slot="next"><span class="fas fa-lock"></span> Sign up</slot>
    </BaseNaviButtons>
  </fieldset>
</template>

<script>
  import BaseNaviButtons from '@/components/BaseNaviButtons'
  import SignupLegend from '@/components/SignupLegend'

  export default {
    components: {
      BaseNaviButtons,
      SignupLegend
    },
    props: {
      formData: Object
    }
  }
</script>

<style scoped>
</style>
